// Import Firebase modules
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAXdMq1yYixAF1ssmnp6H6NTcpd3l-ToWY",
  authDomain: "digital-signage-c9657.firebaseapp.com",
  projectId: "digital-signage-c9657",
  storageBucket: "digital-signage-c9657.firebasestorage.app", // Corrected format
  messagingSenderId: "764946079094",
  appId: "1:764946079094:web:c542892b141b5c8bacae57",
  measurementId: "G-W3FZ79EVE6",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app); // Initialize Authentication
const db = getFirestore(app); // Initialize Firestore
const storage = getStorage(app); // Initialize Storage

export { app, auth, db, storage };
